import React, { createContext, useContext, useEffect, useState } from "react";
import ApiService from "services/ApiService";
import { repeatEffect, settingsConfig } from "utils/commonFunc";

const TrafficTotalContext = createContext(null);

export function SwItsEvntTotalProvider({ children }) {
  const [currentData, setCurrentData] = useState();

  useEffect(() => {
    return repeatEffect(async () => {
      const response = await ApiService.get("newdashboard/integrated/GetEvnt");
      if (response.status === 200) {
        const data = response.data;

        setCurrentData({
          updateTime: data.updateTime,
          todayValue: data.rows[0].todayValue,
          rangeValue: data.rows[0].ragneValue,
          changeValue: data.diffPct.toFixed(2),
        });
      }
    }, settingsConfig().contentUpdateDelaySec);
  }, []);

  return (
    <TrafficTotalContext.Provider value={currentData}>
      {children}
    </TrafficTotalContext.Provider>
  );
}

// export function SwItsEvntTotalInfo() {
//     const currentData = useContext(TrafficTotalContext);
//     if (!currentData) return null;

//     return (
//         <div className='flx flx_col a_center'>
//             <div className='flx a_flx_end'>
//                 <span style={{fontSize: 'var(--ft-80)', fontWeight:'var(--ft-Bold)'}}>{currentData.todayValue}</span>
//                 <span className='subTxt'style={{marginLeft: '22px',}}>회</span>
//             </div>
//             <div className='flx a_center j_center'>
//                 <span className='cmpr' style={{ marginRight: '10px', }}>전월대비</span>
//                 <span className='cmpr minus' style={{ fontWeight: 'var(--ft-Bold)', }}>+ {currentData.changeValue}</span>
//                 <span className='cmpr' style={{ marginLeft: '10px', }}>%</span>
//             </div>
//         </div>
//     );
// }

export function SwItsEvntTotalInfo() {
  const currentData = useContext(TrafficTotalContext);
  if (!currentData) return null;
  const changeValueClass =
    parseFloat(currentData.changeValue) >= 0 ? "plus" : "minus";
    const date = new Date(currentData.updateTime);
    let hours = date.getHours() - 1;
    if (hours < 0) hours = 23;
    hours = String(hours).padStart(2, "0");
  return (
    <div className="flx flx_col a_center">
      <div className="flx a_flx_end">
        <span className="nbr">{currentData.todayValue?.toLocaleString()}</span>
        <span className="subTxt" style={{ marginLeft: "22px" }}>
          건/시
        </span>
      </div>
      <div className="flx a_center j_center">
      <span className="cmpr" style={{ marginRight: "10px" }}>
          월 평균
        </span>
        <span className="cmpr" style={{ marginRight: "10px" }}>
          {hours}시 대비
        </span>
        <span
          className={`cmpr ${changeValueClass}`}
          style={{ fontWeight: "var(--ft-Bold)" }}
        >
          {parseFloat(currentData.changeValue) >= 0 ? "+ " : "- "}
          {Math.abs(currentData.changeValue).toFixed(1)}
        </span>
        <span className="cmpr" style={{ marginLeft: "10px" }}>
          %
        </span>
      </div>
    </div>
  );
}
